import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { string, arrayOf, shape, func, bool, number } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ListItem, ColorItem } from 'components';
import { colorFamiliesShape } from 'shapes';

import './CommonColorList.scss';

export default class CommonColorList extends PureComponent {
    static propTypes = {
        label: string.isRequired,
        items: arrayOf(
            shape({
                label: string.isRequired,
                isRefined: bool,
                count: number,
            }),
        ).isRequired,
        onClick: func.isRequired,
        colorFamilies: colorFamiliesShape.isRequired,
        nbOfDisplayedResults: number.isRequired,
        onShowMoreResults: func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {};

        this.initialResultsLimit = props.nbOfDisplayedResults;
    }

    shouldShowMoreButton = () => {
        const { items, nbOfDisplayedResults } = this.props;
        return (
            items.length >= this.initialResultsLimit &&
            nbOfDisplayedResults < items.length
        );
    };

    render() {
        const {
            label,
            items,
            onClick,
            colorFamilies,
            nbOfDisplayedResults,
            onShowMoreResults,
        } = this.props;

        const buttonClassnames = classnames('colorList__moreButton', {
            'colorList__moreButton--hidden':
                nbOfDisplayedResults >= items.length,
        });

        return (
            <div className="colorList">
                {items
                    .filter(itemColor =>
                        colorFamilies.doesColorExist(itemColor.label),
                    )
                    .slice(0, nbOfDisplayedResults)
                    .map(item => {
                        const color = colorFamilies.getFamilyColorByName(
                            item.label,
                        );
                        return (
                            <ListItem
                                key={`${label}_${item.label}`}
                                label={item.label}
                                color={color}
                                checked={item.isRefined}
                                count={item.count}
                                onClick={onClick}
                                checkbox={ColorItem}
                                value={item.label}
                                className="filter-color-item"
                                dataQa="listItemCta"
                            />
                        );
                    })}

                {this.shouldShowMoreButton() && (
                    <button
                        className={buttonClassnames}
                        onClick={onShowMoreResults}
                        data-qa="moreItemsCta"
                    >
                        <FormattedMessage
                            id="listing.filters.disjunctiveFilter.moreResultButtonLabel"
                            defaultMessage="More {name}"
                            description="Button to show more items in list of disjunctive filter"
                            values={{
                                name: label,
                            }}
                        />
                    </button>
                )}
                {items.length === 0 && (
                    <div className="common-color-list__no-results">
                        <FormattedMessage
                            id="listing.filters.noResult"
                            defaultMessage="No result"
                            description="No result label"
                        />
                    </div>
                )}
            </div>
        );
    }
}
